import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["flex", "flexInline", "flexRow", "flexRowReverse", "flexCol", "flexColReverse", "flexColToRow", "flexWrap", "flexNoWrap", "flexWrapReverse", "flexJustifyStart", "flexJustifyEnd", "flexJustifyCenter", "flexJustifyBetween", "flexJustifyAround", "flexAlignItemsStart", "flexAlignItemsEnd", "flexAlignItemsCenter", "flexAlignItemsStretch", "flexAlignItemsBaseline", "flexAlignContentStart", "flexAlignContentEnd", "flexAlignContentCenter", "flexAlignContentStretch", "flexAlignContentBetween", "flexAlignContentAround", "flexAlignSelfStart", "flexAlignSelfEnd", "flexAlignSelfCenter", "flexAlignSelfStretch", "flexAlignSelfBaseline", "flexAlignSelfLastBaseline", "flexAlignSelfAuto", "flexOrderFirst", "flexOrderLast", "flexOrderNone", "flexGrow1", "flexGrow2", "flexGrow3", "flexGrow4", "flexGrow5", "flexShrink0", "flexShrink1", "flexShrink2", "flexShrink3", "flexShrink4", "flexShrink5", "flexExpand", "flexExpandLeft", "flexExpandRight", "flexExpandTop", "flexExpandBottom", "flexBasisAuto", "flexBasis0", "flexBasis100", "flexInitial", "flexAuto", "flexNone"];
import { propsToClasses } from '../utils';
var styles = {
  "flex": "Flex-flex_uh_R2",
  "flexInline": "Flex-flexInline_PeciM",
  "flexRow": "Flex-flexRow_3mU8l",
  "flexRowReverse": "Flex-flexRowReverse_uwPBQ",
  "flexCol": "Flex-flexCol_1WYpw",
  "flexColReverse": "Flex-flexColReverse_30xDj",
  "flexColToRow": "Flex-flexColToRow_17Y3R",
  "flexWrap": "Flex-flexWrap_2RRPG",
  "flexNoWrap": "Flex-flexNoWrap_3vhRl",
  "flexWrapReverse": "Flex-flexWrapReverse_1zw7y",
  "flexJustifyStart": "Flex-flexJustifyStart_2r9-f",
  "flexJustifyEnd": "Flex-flexJustifyEnd_1I0qk",
  "flexJustifyCenter": "Flex-flexJustifyCenter_-VSdM",
  "flexJustifyBetween": "Flex-flexJustifyBetween_1JGpd",
  "flexJustifyAround": "Flex-flexJustifyAround_O1bRU",
  "flexAlignItemsStart": "Flex-flexAlignItemsStart_27RLN",
  "flexAlignItemsEnd": "Flex-flexAlignItemsEnd_2Mv_z",
  "flexAlignItemsCenter": "Flex-flexAlignItemsCenter_3oJ12",
  "flexAlignItemsStretch": "Flex-flexAlignItemsStretch_2_zx5",
  "flexAlignItemsBaseline": "Flex-flexAlignItemsBaseline_Qzuyi",
  "flexAlignContentStart": "Flex-flexAlignContentStart_7wGsR",
  "flexAlignContentEnd": "Flex-flexAlignContentEnd_2J4pv",
  "flexAlignContentCenter": "Flex-flexAlignContentCenter_zoB-I",
  "flexAlignContentStretch": "Flex-flexAlignContentStretch_2P5-E",
  "flexAlignContentBetween": "Flex-flexAlignContentBetween_2dgoy",
  "flexAlignContentAround": "Flex-flexAlignContentAround_1P22S",
  "flexAlignSelfStart": "Flex-flexAlignSelfStart_2MYj-",
  "flexAlignSelfEnd": "Flex-flexAlignSelfEnd_3nXY2",
  "flexAlignSelfCenter": "Flex-flexAlignSelfCenter_1XHq-",
  "flexAlignSelfStretch": "Flex-flexAlignSelfStretch_xq-G9",
  "flexAlignSelfBaseline": "Flex-flexAlignSelfBaseline_1p8x8",
  "flexAlignSelfLastBaseline": "Flex-flexAlignSelfLastBaseline_2TnXg",
  "flexAlignSelfAuto": "Flex-flexAlignSelfAuto_2zAas",
  "flexOrderFirst": "Flex-flexOrderFirst_2qwnA",
  "flexOrderLast": "Flex-flexOrderLast_3fX3Y",
  "flexOrderNone": "Flex-flexOrderNone_hRrbS",
  "flexGrow1": "Flex-flexGrow1_2dKRn",
  "flexGrow2": "Flex-flexGrow2_gywa7",
  "flexGrow3": "Flex-flexGrow3_23L00",
  "flexGrow4": "Flex-flexGrow4_2XQ3A",
  "flexGrow5": "Flex-flexGrow5_2KEFT",
  "flexShrink0": "Flex-flexShrink0_2EfJF",
  "flexShrink1": "Flex-flexShrink1_3Z4kv",
  "flexShrink2": "Flex-flexShrink2_3LDOP",
  "flexShrink3": "Flex-flexShrink3_3JMYk",
  "flexShrink4": "Flex-flexShrink4_1Idh7",
  "flexShrink5": "Flex-flexShrink5_3FKxu",
  "flexExpand": "Flex-flexExpand_2dpFs",
  "flexExpandLeft": "Flex-flexExpandLeft_3MSjE",
  "flexExpandRight": "Flex-flexExpandRight_18IG6",
  "flexExpandTop": "Flex-flexExpandTop_2g5Zs",
  "flexExpandBottom": "Flex-flexExpandBottom_3u4n_",
  "flexBasisAuto": "Flex-flexBasisAuto_2JPKP",
  "flexBasis0": "Flex-flexBasis0_2UDiU",
  "flexBasis100": "Flex-flexBasis100_3CtzP",
  "flexInitial": "Flex-flexInitial_2U6UN",
  "flexAuto": "Flex-flexAuto_1PxFn",
  "flexNone": "Flex-flexNone_2uGBx"
};
/**  @component */ // eslint-disable-next-line
export function Documentation(props) {}
export function useFlex(props) {
  var flex = props.flex,
    flexInline = props.flexInline,
    flexRow = props.flexRow,
    flexRowReverse = props.flexRowReverse,
    flexCol = props.flexCol,
    flexColReverse = props.flexColReverse,
    flexColToRow = props.flexColToRow,
    flexWrap = props.flexWrap,
    flexNoWrap = props.flexNoWrap,
    flexWrapReverse = props.flexWrapReverse,
    flexJustifyStart = props.flexJustifyStart,
    flexJustifyEnd = props.flexJustifyEnd,
    flexJustifyCenter = props.flexJustifyCenter,
    flexJustifyBetween = props.flexJustifyBetween,
    flexJustifyAround = props.flexJustifyAround,
    flexAlignItemsStart = props.flexAlignItemsStart,
    flexAlignItemsEnd = props.flexAlignItemsEnd,
    flexAlignItemsCenter = props.flexAlignItemsCenter,
    flexAlignItemsStretch = props.flexAlignItemsStretch,
    flexAlignItemsBaseline = props.flexAlignItemsBaseline,
    flexAlignContentStart = props.flexAlignContentStart,
    flexAlignContentEnd = props.flexAlignContentEnd,
    flexAlignContentCenter = props.flexAlignContentCenter,
    flexAlignContentStretch = props.flexAlignContentStretch,
    flexAlignContentBetween = props.flexAlignContentBetween,
    flexAlignContentAround = props.flexAlignContentAround,
    flexAlignSelfStart = props.flexAlignSelfStart,
    flexAlignSelfEnd = props.flexAlignSelfEnd,
    flexAlignSelfCenter = props.flexAlignSelfCenter,
    flexAlignSelfStretch = props.flexAlignSelfStretch,
    flexAlignSelfBaseline = props.flexAlignSelfBaseline,
    flexAlignSelfLastBaseline = props.flexAlignSelfLastBaseline,
    flexAlignSelfAuto = props.flexAlignSelfAuto,
    flexOrderFirst = props.flexOrderFirst,
    flexOrderLast = props.flexOrderLast,
    flexOrderNone = props.flexOrderNone,
    flexGrow1 = props.flexGrow1,
    flexGrow2 = props.flexGrow2,
    flexGrow3 = props.flexGrow3,
    flexGrow4 = props.flexGrow4,
    flexGrow5 = props.flexGrow5,
    flexShrink0 = props.flexShrink0,
    flexShrink1 = props.flexShrink1,
    flexShrink2 = props.flexShrink2,
    flexShrink3 = props.flexShrink3,
    flexShrink4 = props.flexShrink4,
    flexShrink5 = props.flexShrink5,
    flexExpand = props.flexExpand,
    flexExpandLeft = props.flexExpandLeft,
    flexExpandRight = props.flexExpandRight,
    flexExpandTop = props.flexExpandTop,
    flexExpandBottom = props.flexExpandBottom,
    flexBasisAuto = props.flexBasisAuto,
    flexBasis0 = props.flexBasis0,
    flexBasis100 = props.flexBasis100,
    flexInitial = props.flexInitial,
    flexAuto = props.flexAuto,
    flexNone = props.flexNone,
    extraProps = _objectWithoutProperties(props, _excluded);
  var classes = propsToClasses(props, styles);
  return [classes, extraProps];
}